import { Spinner } from "@garther/ui/components";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/test")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div>
      <Spinner />
    </div>
  );
}
